import { type SalesMetricV2 } from "./types";

export function makeTwitterClicks(): SalesMetricV2 {
  const id = "twitterClicks";
  const name = "Twitter Clicks";

  return {
    id,
    name,
    fullName: name,
    description: "User clicks a Twitter ad",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterAppClicks(): SalesMetricV2 {
  const id = "twitterAppClicks";
  const name = "Twitter App Clicks";

  return {
    id,
    name,
    fullName: name,
    description: "User clicks a Twitter ad in app",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterLikes(): SalesMetricV2 {
  const id = "twitterLikes";
  const name = "Twitter Likes";

  return {
    id,
    name,
    fullName: name,
    description: "Number of likes from users",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterFollows(): SalesMetricV2 {
  const id = "twitterFollows";
  const name = "Twitter Follows";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter Follows",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterRetweets(): SalesMetricV2 {
  const id = "twitterRetweets";
  const name = "Twitter Retweets";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter Retweets",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterUnfollows(): SalesMetricV2 {
  const id = "twitterUnfollows";
  const name = "Twitter Unfollows";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter Unfollows",
    category: "twitter",
    positiveTrend: "down",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterEngagements(): SalesMetricV2 {
  const id = "twitterEngagements";
  const name = "Twitter Engagements";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter Engagements",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterReplies(): SalesMetricV2 {
  const id = "twitterReplies";
  const name = "Twitter Replies";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter Replies",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeTwitterUrlClicks(): SalesMetricV2 {
  const id = "twitterUrlClicks";
  const name = "Twitter URL Clicks";

  return {
    id,
    name,
    fullName: name,
    description: "Twitter URL Clicks",
    category: "twitter",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}
